// Фокус окна поверх экрана (HQ-1402): при открытии — внутрь окна, при закрытии — обратно на элемент, с которого открыли.
// Без этого диктор и клавиатура после каждого листа начинали с начала страницы.
import { type RefObject, useEffect } from 'react';

/** Что получает фокус с клавиатуры: первое такое внутри окна берёт фокус при открытии. */
export const FOCUSABLE_SELECTOR =
  'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

function focusQuietly(el: HTMLElement): void {
  el.focus({ preventScroll: true });
}

/** Переводит фокус в окно и возвращает функцию возврата фокуса на прежний `document.activeElement`. */
export function trapDialogFocus(dialog: HTMLElement, doc: Document = document): () => void {
  const previous = doc.activeElement as HTMLElement | null;
  const first = dialog.querySelector<HTMLElement>(FOCUSABLE_SELECTOR);
  if (first) focusQuietly(first);
  else {
    dialog.tabIndex = -1;
    focusQuietly(dialog);
  }
  return () => {
    if (previous && previous.isConnected && typeof previous.focus === 'function') focusQuietly(previous);
  };
}

/** Хук окна: `ref` — элемент с role="dialog"/"alertdialog". */
export function useDialogFocus(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    return trapDialogFocus(dialog, dialog.ownerDocument);
  }, [ref]);
}
